import { useContext, useEffect, useState } from "react";
import { Button, message, Row, Table } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import type { ColumnsType } from "antd/es/table";

import { deleteGroupApi, renameGroupApi } from "../../axios/portalData";
import SelectedGroupContext from "../../themeContext/selectedGroupContext";
import CreateNewGroupPopup from "../CreateNewGroup/createNewGroupPopup";
import Confirmation from "../Common/Confirmation";
import { TextEditCell } from "../../Pages/account";

import "./styles.less";
import GroupsMachinesReFetchFlagContext from "../../themeContext/GroupsMachinesReFetchFlagContext";
import GroupDocumentContext from "../../themeContext/GroupDocumentContext";

export type group = {
  name: string;
  machines: number;
};

const Groups: React.FC = () => {
  const { selectedGroup, setSelectedGroup } = useContext(SelectedGroupContext);

  const [groups, setGroups] = useState<string[]>([]);
  const [groupsData, setGroupsData] = useState<group[] | undefined>(undefined);
  const { setGroupsMachinesReFetchFlag } = useContext(GroupsMachinesReFetchFlagContext);
  const { groupDocument } = useContext(GroupDocumentContext);

  const [newGroupModal, setNewGroupModal] = useState<boolean>(false);
  const [deleteGroupName, setDeleteGroupName] = useState<string | undefined>(undefined);

  const onDeleteClicked = (groupName: string) => {
    setDeleteGroupName(groupName);
  };
  const deleteGroup = () => {
    setGroupsData(undefined);
    setDeleteGroupName(undefined);
    deleteGroupApi(deleteGroupName as string)
      .then((resp) => {
        message.success(resp);
        if (deleteGroupName == selectedGroup) {
          setSelectedGroup("None");
        }
        setGroupsMachinesReFetchFlag(true);
      })
      .catch((error) => {
        console.log(error);
        message.error("Error :: deleting the group");
        getGroups();
      });
  };

  const renameGroup = (groupName: string, newGroupName: string) => {
    if (groupName != newGroupName) {
      setGroupsData(undefined);
      renameGroupApi(groupName, newGroupName)
        .then((resp) => {
          message.success(resp);
          if (groupName == selectedGroup) {
            setSelectedGroup(newGroupName);
          }
          setGroupsMachinesReFetchFlag(true);
        })
        .catch((error) => {
          message.error(error.message);
          getGroups();
        });
    }
  };
  const columns: ColumnsType<group> = [
    {
      title: "Name",
      dataIndex: "name",
      render: (name) =>
        name != "None" ? <TextEditCell value={name} handleClickDone={(value) => renameGroup(name, value)} /> : name,
    },
    {
      title: "Number of Machines",
      dataIndex: "machines",
      align: "right",
    },
    {
      title: "Actions",
      dataIndex: "name",
      align: "center",
      render: (name) =>
        name != "None" ? <DeleteOutlined className="icon" onClick={() => onDeleteClicked(name)} /> : <></>,
    },
  ];

  const onNewGroupModalClose = (refresh?: boolean) => {
    refresh ? getGroups() : "";
    setNewGroupModal(false);
  };

  const getGroups = () => {
    const groupsData: group[] = [];
    const groupNames = Object.keys(groupDocument.groupDocument.groups);
    groupNames.forEach((e) => {
      groupsData.push({
        name: e,
        machines: groupDocument.groupDocument.groups[e]?.length ?? 0,
      });
    });
    setGroupsData(groupsData);
    setGroups(groupNames);
  };
  useEffect(() => {
    getGroups();
  }, [groupDocument]);

  return (
    <div className="settings-panel groups">
      <Row>
        <Table
          loading={groupsData === undefined}
          className="settings-table groups"
          scroll={{ x: "none", y: 300 }}
          columns={columns}
          dataSource={groupsData}
          pagination={false}
          locale={{
            emptyText: groupsData ? "No groups" : "Loading groups",
          }}
          rowKey={"name"}
        />
      </Row>
      <Row className="btn-grp-wrapper">
        <Button className="secondary-button" onClick={() => setNewGroupModal(true)}>
          {" "}
          New Group
        </Button>
      </Row>

      <CreateNewGroupPopup
        groups={groups}
        visible={newGroupModal}
        closeModal={(refresh) => onNewGroupModalClose(refresh)}
        setGroups={setGroups}
        setSelectedGroup={setSelectedGroup}
      />

      {deleteGroupName ? (
        <Confirmation
          okText="Delete anyway"
          titleText="If group is deleted, all machines in this group will become ungrouped."
          messageText="You cannot undo this action."
          onOk={() => deleteGroup()}
          onClose={() => setDeleteGroupName(undefined)}
        />
      ) : (
        ""
      )}
    </div>
  );
};
export default Groups;
